

























import { Mixins, Component, Ref } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import CatalogueSettingsMixin from "@/mixins/http/CatalogueSettingsMixin";
import OperationProgress from "@/components/CatalogueSettings/OperationProgress.vue";
import jsFileDownloader from "js-file-downloader";
import { authStore } from "@/store/typed";

const DOWNLOAD_CATALOGUE_TAG = "download_catalogue_tag";

@Component({
  components: {
    OperationProgress,
    VModal,
  },
})
export default class Download extends Mixins(CatalogueSettingsMixin) {
  @Ref("exportCatalogue") readonly exportModal!: VModal;

  private showDownloadBtn = false;
  private documentData: any | null = null;

  show() {
    this.exportModal.show();
    this.initExportRequest();
  }

  get documentUrl() {
    return this.documentData ? this.documentData.result : null;
  }

  async onCompleted(payload: any) {
    this.documentData = payload;
    this.showDownloadBtn = true;
  }

  onFailed(payload: any) {
    this.exportModal.hide();
  }

  async initExportRequest() {
    const resp = await this.downloadCatalogue(DOWNLOAD_CATALOGUE_TAG);
  }
}
